export var fetchingTime: number = 2*60*1000; // 2 mins in ms